<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
<div class="mrf2">
  <header class="mrf2__page-head">
    <div class="mrf2__title-row">
      <h1 class="mrf2__title">Manpower Requisition Form</h1>
      <div class="mrf-header-statuses">
        <div class="mrf-header-status" *ngIf="requestStatusLabel">
          <span class="mrf-header-status__lbl">MRF Status</span>
          <span class="mrf-header-status__sep">-</span>
          <span class="mrf-header-status__val" [attr.data-tone]="requestStatusTone">{{ requestStatusLabel }}</span>
        </div>
        <div class="mrf-header-status" *ngIf="onboardingStatusLabel">
          <span class="mrf-header-status__lbl">Onboarding Status</span>
          <span class="mrf-header-status__sep">-</span>
          <span class="mrf-header-status__val" [attr.data-tone]="onboardingStatusTone">{{ onboardingStatusLabel }}</span>
        </div>
      </div>
    </div>
  </header>

  <!-- Read-only summary from previous request -->
  <div class="mrf2__summary-panel">
    <!-- 1 Basic Information -->
    <section class="mrf2__sum-sec mrf2__sum-sec--blue">
      <span class="mrf2__step mrf2__step--blue" aria-hidden="true">1</span>
      <h2 class="mrf2__sec-title mrf2__sec-title--blue">Basic Information</h2>
      <div class="mrf2__row mrf2__row--5">
        <div class="mrf2__ro-fld">
          <span class="mrf2__ro-lbl">Campus Name</span>
          <span class="mrf2__ro-val">{{ mrfData?.campusName || '—' }}</span>
        </div>
        <div class="mrf2__ro-fld">
          <span class="mrf2__ro-lbl">Employee Type</span>
          <span class="mrf2__ro-val">{{ mrfData?.empType || '—' }}</span>
        </div>
        <div class="mrf2__ro-fld">
          <span class="mrf2__ro-lbl">Teaching Type</span>
          <span class="mrf2__ro-val">{{ mrfData?.roleType || mrfData?.TeachType || mrfData?.teachingType || '—' }}</span>
        </div>
        <div class="mrf2__ro-fld">
          <span class="mrf2__ro-lbl">Department</span>
          <span class="mrf2__ro-val">{{ mrfData?.departmentName || mrfData?.deptName || '—' }}</span>
        </div>
        <div class="mrf2__ro-fld">
          <span class="mrf2__ro-lbl">Designation</span>
          <span class="mrf2__ro-val">{{ mrfData?.desigName || mrfData?.designation || '—' }}</span>
        </div>
        <div class="mrf2__ro-fld" *ngIf="mrfData?.subName || mrfData?.subjectName">
          <span class="mrf2__ro-lbl">Subject</span>
          <span class="mrf2__ro-val">{{ mrfData?.subName || mrfData?.subjectName || '—' }}</span>
        </div>
        <div class="mrf2__ro-fld" *ngIf="mrfData?.workLoad">
          <span class="mrf2__ro-lbl">WorkLoad per day</span>
          <span class="mrf2__ro-val">{{ mrfData?.workLoad }}</span>
        </div>
      </div>
    </section>

    <!-- 2 Position Type -->
    <section class="mrf2__sum-sec mrf2__sum-sec--purple">
      <span class="mrf2__step mrf2__step--purple" aria-hidden="true">2</span>
      <h2 class="mrf2__sec-title mrf2__sec-title--purple">Position Type</h2>
      <div class="mrf2__row mrf2__row--5">
        <div class="mrf2__ro-fld">
          <span class="mrf2__ro-lbl">Position Type</span>
          <span class="mrf2__ro-val">{{ mrfData?.positionType || '—' }}</span>
        </div>
        <div class="mrf2__ro-fld" *ngIf="mrfData?.hiringReason">
          <span class="mrf2__ro-lbl">Reason for Hiring</span>
          <span class="mrf2__ro-val">{{ mrfData?.hiringReason }}</span>
        </div>
      </div>
      <div class="mrf2__row mrf2__row--5" *ngIf="isNewPosition">
        <div class="mrf2__ro-fld">
          <span class="mrf2__ro-lbl">Designation</span>
          <span class="mrf2__ro-val">{{ displayField('newPositionDesigName', 'positionDesignation', 'posDesigName', 'desigName', 'designation') || '—' }}</span>
        </div>
      </div>
      <div class="mrf2__row mrf2__row--5" *ngIf="isReplacement">
        <div class="mrf2__ro-fld">
          <span class="mrf2__ro-lbl">Payroll Id</span>
          <span class="mrf2__ro-val">{{ mrfData?.replacementEmpId || '—' }}</span>
        </div>
        <div class="mrf2__ro-fld">
          <span class="mrf2__ro-lbl">Name</span>
          <span class="mrf2__ro-val">{{ mrfData?.replacementEmpName || '—' }}</span>
        </div>
        <div class="mrf2__ro-fld">
          <span class="mrf2__ro-lbl">Designation</span>
          <span class="mrf2__ro-val">{{ mrfData?.replacementDesigName || mrfData?.replacementDesignation || '—' }}</span>
        </div>
        <div class="mrf2__ro-fld" *ngIf="isReasonExit">
          <span class="mrf2__ro-lbl">Last Working Date</span>
          <span class="mrf2__ro-val">{{ displayLastWorkingDate() }}</span>
        </div>
        <div class="mrf2__ro-fld">
          <span class="mrf2__ro-lbl">Current CTC</span>
          <span class="mrf2__ro-val">{{ displayAmountField('currentCTC', 'ctc', 'currentSalary', 'prevRepEmpCtc') }}</span>
        </div>
      </div>
    </section>

    <!-- 3 Headcount Information -->
    <section class="mrf2__sum-sec mrf2__sum-sec--green">
      <span class="mrf2__step mrf2__step--green" aria-hidden="true">3</span>
      <h2 class="mrf2__sec-title mrf2__sec-title--green">Headcount Information</h2>
      <div class="mrf2__row mrf2__row--3">
        <div class="mrf2__ro-fld">
          <span class="mrf2__ro-lbl">No. of Budgeted Positions</span>
          <span class="mrf2__ro-val">{{ budgetedPositions }}</span>
        </div>
        <div class="mrf2__ro-fld">
          <span class="mrf2__ro-lbl">No. of Headcount</span>
          <span class="mrf2__ro-val">{{ noOfHeadcount }}</span>
        </div>
        <div class="mrf2__ro-fld">
          <span class="mrf2__ro-lbl">Available Headcount</span>
          <span class="mrf2__ro-val mrf2__ro-val--green">{{ availableHeadcount }}</span>
        </div>
      </div>
    </section>

    <!-- 4 Qualification & Skills -->
    <section class="mrf2__sum-sec mrf2__sum-sec--orange">
      <span class="mrf2__step mrf2__step--orange" aria-hidden="true">4</span>
      <h2 class="mrf2__sec-title mrf2__sec-title--orange">Qualification &amp; Skills</h2>
      <div class="mrf2__row mrf2__row--4">
        <div class="mrf2__ro-fld">
          <span class="mrf2__ro-lbl">Educational Qualification</span>
          <span class="mrf2__ro-val">{{ mrfData?.qualificationName || mrfData?.qualification || '—' }}</span>
        </div>
        <div class="mrf2__ro-fld">
          <span class="mrf2__ro-lbl">Additional Qualification</span>
          <span class="mrf2__ro-val">{{ mrfData?.additionalQualification || '—' }}</span>
        </div>
        <div class="mrf2__ro-fld">
          <span class="mrf2__ro-lbl">Years of Experience</span>
          <span class="mrf2__ro-val">{{ displayYearsOfExperience() }}</span>
        </div>
        <div class="mrf2__ro-fld">
          <span class="mrf2__ro-lbl">Skills</span>
          <span class="mrf2__ro-val">{{ mrfData?.skills || '—' }}</span>
        </div>
      </div>
    </section>

    <!-- 5 Reporting Structure -->
    <section class="mrf2__sum-sec mrf2__sum-sec--teal">
      <span class="mrf2__step mrf2__step--teal" aria-hidden="true">5</span>
      <h2 class="mrf2__sec-title mrf2__sec-title--teal">Reporting Structure</h2>
      <div class="mrf2__row mrf2__row--3">
        <div class="mrf2__ro-fld">
          <span class="mrf2__ro-lbl">Reporting Manager</span>
          <span class="mrf2__ro-val">{{ displayReportingManager() }}</span>
        </div>
      </div>
    </section>

    <!-- 6 Qualified Employee Details -->
    <section class="mrf2__sum-sec mrf2__sum-sec--blue mrf2__sum-sec--last">
      <span class="mrf2__step mrf2__step--blue" aria-hidden="true">6</span>
      <h2 class="mrf2__sec-title mrf2__sec-title--blue">Qualified Employee Details</h2>
      <div class="mrf2__row mrf2__row--2 mrf2__row--new-emp-head">
        <div class="mrf2__ro-fld">
          <span class="mrf2__ro-lbl">Exam Taken</span>
          <div class="mrf2__exam-radio-row" role="group" aria-label="Exam taken">
            <span class="mrf2__exam-radio" [class.mrf2__exam-radio--on]="isExamTaken('yes')">
              <span class="mrf2__exam-radio-dot" aria-hidden="true"></span>
              Yes
            </span>
            <span class="mrf2__exam-radio" [class.mrf2__exam-radio--on]="isExamTaken('no')">
              <span class="mrf2__exam-radio-dot" aria-hidden="true"></span>
              No
            </span>
          </div>
        </div>
        <div class="mrf2__ro-fld" *ngIf="isExamTaken('yes')">
          <span class="mrf2__ro-lbl">Employee Temp Id</span>
          <span class="mrf2__ro-val">{{ displayTempPayrollId() }}</span>
        </div>
        <div class="mrf2__ro-fld" *ngIf="isExamTaken('no') && hasTempPayrollId()">
          <span class="mrf2__ro-lbl">Temp Payroll Id</span>
          <span class="mrf2__ro-val">{{ displayTempPayrollId() }}</span>
        </div>
      </div>
      <!-- <div class="mrf2__row mrf2__row--3" *ngIf="isRehiring && isExamTaken('no')">
        <div class="mrf2__ro-fld">
          <span class="mrf2__ro-lbl">Rehiring Employee Name</span>
          <span class="mrf2__ro-val">{{ displayRehiringEmployeeName() }}</span>
        </div>
        <div class="mrf2__ro-fld">
          <span class="mrf2__ro-lbl">Designation</span>
          <span class="mrf2__ro-val">{{ displayField('prevEmpDesignation') }}</span>
        </div>
        <div class="mrf2__ro-fld">
          <span class="mrf2__ro-lbl">Mobile No.</span>
          <span class="mrf2__ro-val">{{ displayField('mobileNo', 'mobileNumber', 'phoneNo') }}</span>
        </div>
      </div> -->
      <div class="mrf2__row mrf2__row--5 mrf2__row--new-emp-top">
        <div class="mrf2__ro-fld">
          <span class="mrf2__ro-lbl">Name</span>
          <span class="mrf2__ro-val">{{ displayEmployeeName() }}</span>
        </div>
        <div class="mrf2__ro-fld">
          <span class="mrf2__ro-lbl">Surname</span>
          <span class="mrf2__ro-val">{{ displaySurname() }}</span>
        </div>
        <div class="mrf2__ro-fld">
          <span class="mrf2__ro-lbl">Mobile No.</span>
          <span class="mrf2__ro-val">{{ displayField('mobileNo', 'mobileNumber', 'candidateMobile', 'mobile', 'phoneNo') }}</span>
        </div>
        <div class="mrf2__ro-fld">
          <span class="mrf2__ro-lbl">Aadhaar Card No.</span>
          <span class="mrf2__ro-val">{{ displayField('newEmpAadhar', 'aadharCardNo', 'candidateAadhar', 'aadharNo', 'aadhaarNo') }}</span>
          <ng-container *ngTemplateOutlet="fileChips; context: { docs: aadhaarDocuments }"></ng-container>
        </div>
        <div class="mrf2__ro-fld">
          <span class="mrf2__ro-lbl">Pan Card No.</span>
          <span class="mrf2__ro-val">{{ displayField('panNo', 'panCardNo', 'candidatePan', 'panNumber', 'panCardNumber') }}</span>
          <ng-container *ngTemplateOutlet="fileChips; context: { docs: panDocuments }"></ng-container>
        </div>
      </div>
      <div
        class="mrf2__row mrf2__row--new-emp-bottom"
        [class.mrf2__row--3]="!isReplacement"
        [class.mrf2__row--4]="isReplacement"
      >
        <div class="mrf2__ro-fld">
          <span class="mrf2__ro-lbl">DOB</span>
          <span class="mrf2__ro-val">{{ displayDob() }}</span>
        </div>
        <div class="mrf2__ro-fld">
          <span class="mrf2__ro-lbl">Expected Salary</span>
          <span
            class="mrf2__ro-val"
            [class.mrf2__ro-val--budget-error]="isExpectedSalaryOverAvailableBudget || isReplacementSalaryOverPercentageLimit"
          >{{ displayAmountField('expectedSalary', 'salaryBudget', 'expectedCTC', 'salary') }}</span>
        </div>
        <div class="mrf2__ro-fld" *ngIf="isReplacement">
          <span class="mrf2__ro-lbl">Hike Percentage</span>
          <span class="mrf2__ro-val">{{ prevRepEmpCtcPlusPercentageLabel }}</span>
        </div>
        <div class="mrf2__ro-fld mrf2__new-emp-upload" *ngIf="isExamTaken('yes')">
          <span class="mrf2__ro-lbl">Upload Exam Copy</span>
          <ng-container *ngTemplateOutlet="fileChips; context: { docs: examDocuments }"></ng-container>
        </div>
      </div>

      <ng-container *ngIf="isRehiring">
        <div class="mrf2__chk mrf2__chk--readonly" aria-label="Rehiring">
          <span class="mrf2__chk-ui" [class.mrf2__chk-ui--on]="isRehiring" aria-hidden="true"></span>
          <span class="mrf2__chk-txt">Rehiring</span>
        </div>
        <div class="mrf2__row mrf2__row--3" *ngIf="rehiringPayrollIdDisplay">
          <div class="mrf2__ro-fld">
            <span class="mrf2__ro-lbl">Previous Payroll Id</span>
            <span class="mrf2__ro-val">{{ rehiringPayrollIdDisplay }}</span>
          </div>
          <div class="mrf2__ro-fld">
            <span class="mrf2__ro-lbl">Date of Birth</span>
            <span class="mrf2__ro-val">{{ displayRehiringDob() }}</span>
          </div>
          <div class="mrf2__ro-fld" *ngIf="displayRehiringAadharNo() !== '—'">
            <span class="mrf2__ro-lbl">Aadhaar No.</span>
            <span class="mrf2__ro-val">{{ displayRehiringAadharNo() }}</span>
          </div>
        </div>
      </ng-container>

      <div class="mrf2__row mrf2__row--1" *ngIf="attachedDocuments.length">
        <div class="mrf2__ro-fld">
          <span class="mrf2__ro-lbl">Attached Files</span>
          <ng-container *ngTemplateOutlet="fileChips; context: { docs: attachedDocuments }"></ng-container>
        </div>
      </div>
    </section>
  </div>

  <h1 class="mrf2__dept-title">MIS Department</h1>

  <div class="mrf2__panel">
    <!-- 7 Approved By Campus Level -->
    <section class="mrf2__sec mrf2__sec--blue" aria-labelledby="mrf2-s7">
      <span class="mrf2__step mrf2__step--blue" aria-hidden="true">7</span>
      <h2 id="mrf2-s7" class="mrf2__sec-title mrf2__sec-title--blue">Approved By Campus Level</h2>
      <div class="mrf2__row mrf2__row--3">
        <div class="mrf2__ro-fld">
          <span class="mrf2__ro-lbl">Approved By</span>
          <span class="mrf2__ro-val">{{ displayField('campusLevelApprovedByName', 'approvedByCampusName', 'campusApprovedByName', 'principalDeanName') }}</span>
        </div>
        <div class="mrf2__ro-fld">
          <span class="mrf2__ro-lbl">Employee Id</span>
          <span class="mrf2__ro-val">{{ displayField('campusLevelApproverId', 'approvedByCampusEmpId', 'campusApprovedByEmpId', 'principalEmpId') }}</span>
        </div>
        <div class="mrf2__ro-fld">
          <span class="mrf2__ro-lbl">Designation</span>
          <span class="mrf2__ro-val">{{ displayField('campusLevelApproverDesig', 'approvedByCampusDesig', 'campusApprovedByDesig', 'principalDesigName') }}</span>
        </div>
      </div>
    </section>

    <!-- 8 Policy & Budget Checks -->
    <section class="mrf2__sec mrf2__sec--purple" aria-labelledby="mrf2-s8">
      <span class="mrf2__step mrf2__step--purple" aria-hidden="true">8</span>
      <h2 id="mrf2-s8" class="mrf2__sec-title mrf2__sec-title--purple">Policy &amp; Budget Checks</h2>

      <div class="mrf2__row mrf2__row--3">
        <div class="mrf2__fld">
          <label class="mrf2__lbl">Is This Position Within The Rehire Policy Guidelines?</label>
          <div class="mrf2__radio-group">
            <label class="mrf2__radio mrf2__radio--yes" [class.mrf2__radio--active]="rehirePolicyGuidelines === 'yes'">
              <input type="radio" name="rehirePolicy" value="yes"
                [(ngModel)]="rehirePolicyGuidelines" class="mrf2__radio-inp" [disabled]="isReadOnlyMisSection" />
              <span class="mrf2__radio-dot"></span>
              Yes
            </label>
            <label class="mrf2__radio mrf2__radio--no" [class.mrf2__radio--active]="rehirePolicyGuidelines === 'no'">
              <input type="radio" name="rehirePolicy" value="no"
                [(ngModel)]="rehirePolicyGuidelines" class="mrf2__radio-inp" [disabled]="isReadOnlyMisSection" />
              <span class="mrf2__radio-dot"></span>
              No
            </label>
          </div>
        </div>

        <div class="mrf2__fld">
          <label class="mrf2__lbl">Is This Position Within The Rehire Cost?</label>
          <div class="mrf2__radio-group">
            <label class="mrf2__radio mrf2__radio--yes" [class.mrf2__radio--active]="withinRehireCost === 'yes'">
              <input type="radio" name="rehireCost" value="yes"
                [(ngModel)]="withinRehireCost" class="mrf2__radio-inp" [disabled]="isReadOnlyMisSection" />
              <span class="mrf2__radio-dot"></span>
              Yes
            </label>
            <label class="mrf2__radio mrf2__radio--no" [class.mrf2__radio--active]="withinRehireCost === 'no'">
              <input type="radio" name="rehireCost" value="no"
                [(ngModel)]="withinRehireCost" class="mrf2__radio-inp" [disabled]="isReadOnlyMisSection" />
              <span class="mrf2__radio-dot"></span>
              No
            </label>
          </div>
        </div>

        <div class="mrf2__fld">
          <label class="mrf2__lbl">Is This A Budgeted Position?</label>
          <div class="mrf2__radio-group">
            <label class="mrf2__radio mrf2__radio--yes" [class.mrf2__radio--active]="isBudgetedPosition === 'yes'">
              <input type="radio" name="budgetedPos" value="yes"
                [(ngModel)]="isBudgetedPosition" class="mrf2__radio-inp" [disabled]="isReadOnlyMisSection" />
              <span class="mrf2__radio-dot"></span>
              Yes
            </label>
            <label class="mrf2__radio mrf2__radio--no" [class.mrf2__radio--active]="isBudgetedPosition === 'no'">
              <input type="radio" name="budgetedPos" value="no"
                [(ngModel)]="isBudgetedPosition" class="mrf2__radio-inp" [disabled]="isReadOnlyMisSection" />
              <span class="mrf2__radio-dot"></span>
              No
            </label>
          </div>
        </div>
      </div>
    </section>

    <!-- 9 Job Description & Justification -->
    <section class="mrf2__sec mrf2__sec--red" aria-labelledby="mrf2-s9">
      <span class="mrf2__step mrf2__step--red" aria-hidden="true">9</span>
      <h2 id="mrf2-s9" class="mrf2__sec-title mrf2__sec-title--red">Job Description &amp; Justification</h2>

      <div class="mrf2__fld mrf2__fld--mb">
        <label class="mrf2__lbl">Has The Job Description Been Attached?</label>
        <div class="mrf2__radio-group">
          <label class="mrf2__radio mrf2__radio--yes" [class.mrf2__radio--active]="jobDescriptionAttached === 'yes'">
            <input type="radio" name="jobDescAttached" value="yes"
              [(ngModel)]="jobDescriptionAttached" class="mrf2__radio-inp" [disabled]="isReadOnlyMisSection" />
            <span class="mrf2__radio-dot"></span>
            Yes
          </label>
          <label class="mrf2__radio mrf2__radio--no" [class.mrf2__radio--active]="jobDescriptionAttached === 'no'">
            <input type="radio" name="jobDescAttached" value="no"
              [(ngModel)]="jobDescriptionAttached" class="mrf2__radio-inp" [disabled]="isReadOnlyMisSection" />
            <span class="mrf2__radio-dot"></span>
            No
          </label>
        </div>
      </div>

      <div class="mrf2__fld mrf2__fld--full mrf2__fld--mb">
        <label class="mrf2__lbl">Justification (for Position & Salary)</label>
        <div class="mrf2__ta-wrap">
          <textarea class="mrf2__ta" rows="4" placeholder="Enter justification"
            [formControl]="justification" [maxLength]="justificationMaxLength"></textarea>
          <span class="mrf2__char-count">{{ justificationCount }}/{{ justificationMaxLength }} chars</span>
        </div>
      </div>

      <div class="mrf2__fld mrf2__fld--full mrf2__fld--mb">
        <label class="mrf2__lbl">Work Description / Responsibilities (Attach Job Description)</label>
        <div class="mrf2__ta-wrap">
          <textarea class="mrf2__ta" rows="4" placeholder="Enter work description / responsibilities"
            [formControl]="workDescription" [maxLength]="workDescriptionMaxLength"></textarea>
          <span class="mrf2__char-count">{{ workDescriptionCount }}/{{ workDescriptionMaxLength }} chars</span>
        </div>
      </div>

      <div class="mrf2__doc-saved-block" *ngIf="jobDescDocuments.length">
        <span class="mrf2__lbl">Job Description Files</span>
        <ng-container *ngTemplateOutlet="fileChips; context: { docs: jobDescDocuments }"></ng-container>
      </div>

      <div class="mrf2__attach-block" *ngIf="canEditWorkDescAndApprovalDocs">
        <label class="mrf2__attach" [class.mrf2__attach--disabled]="!canAddMoreFiles('job')"
          (click)="onAttachClick($event, 'job', jobDescFileInput)">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.5 6V17.5C16.5 19.71 14.71 21.5 12.5 21.5C10.29 21.5 8.5 19.71 8.5 17.5V5C8.5 3.62 9.62 2.5 11 2.5C12.38 2.5 13.5 3.62 13.5 5V15.5C13.5 16.05 13.05 16.5 12.5 16.5C11.95 16.5 11.5 16.05 11.5 15.5V6H10V15.5C10 16.88 11.12 18 12.5 18C13.88 18 15 16.88 15 15.5V5C15 2.79 13.21 1 11 1C8.79 1 7 2.79 7 5V17.5C7 20.54 9.46 23 12.5 23C15.54 23 18 20.54 18 17.5V6H16.5Z" fill="#1B6EBA"/>
          </svg>
          <span class="mrf2__attach-txt">Attach files (Job Description)</span>
          <span class="mrf2__doc-hint"> — PDF or image, up to {{ maxPendingFiles }} files</span>
        </label>
        <input
          #jobDescFileInput
          type="file"
          hidden
          multiple
          accept=".pdf,application/pdf,image/*"
          (change)="onFilesSelected($event, 'job')"
        />
        <ul class="mrf2__doc-pending" *ngIf="jobDescPendingFiles.length">
          <li *ngFor="let file of jobDescPendingFiles; let i = index" class="mrf2__doc-pending-item">
            <span class="mrf2__doc-pending-name" [title]="file.name">{{ file.name }}</span>
            <button type="button" class="mrf2__doc-remove" (click)="removePendingFile('job', i)" aria-label="Remove file">×</button>
          </li>
        </ul>
        <p class="mrf2__doc-meta" *ngIf="jobDescPendingFiles.length">
          {{ jobDescPendingFiles.length }}/{{ maxPendingFiles }} selected — uploads on submit
        </p>
        <span class="mrf2__upload-error" *ngIf="getUploadFileError('job')">{{ getUploadFileError('job') }}</span>
      </div>

      <div class="mrf2__fld mrf2__fld--mb">
        <label class="mrf2__lbl">Approved by</label>
        <span class="mrf2__ro-val" *ngIf="isReadOnlyMisSection">{{ getManagementApprovedByDisplayLabel() }}</span>
        <mat-select
          *ngIf="!isReadOnlyMisSection"
          class="mrf2__mat-select"
          placeholder="Select"
          [formControl]="approvedBy2"
          (selectionChange)="onApprovedBySelectionChange($event.value)"
        >
          <input
            matInput
            [matAutocomplete]="approvedByAuto"
            [formControl]="approvedBy"
            class="mrf2__mat-select-input"
            placeholder="Enter name to select"
          />
          <mat-autocomplete autoActiveFirstOption #approvedByAuto="matAutocomplete"></mat-autocomplete>
          <mat-option *ngFor="let item of approvedByOptions | async" [value]="item?.name">
            {{ getApprovedByOptionLabel(item) }}
          </mat-option>
        </mat-select>
      </div>

      <div class="mrf2__doc-saved-block" *ngIf="approvalDocuments.length">
        <span class="mrf2__lbl">Approval Files</span>
        <ng-container *ngTemplateOutlet="fileChips; context: { docs: approvalDocuments }"></ng-container>
      </div>

      <div class="mrf2__attach-block" *ngIf="canEditWorkDescAndApprovalDocs">
        <label class="mrf2__attach" [class.mrf2__attach--disabled]="!canAddMoreFiles('approval')"
          (click)="onAttachClick($event, 'approval', approvalFileInput)">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.5 6V17.5C16.5 19.71 14.71 21.5 12.5 21.5C10.29 21.5 8.5 19.71 8.5 17.5V5C8.5 3.62 9.62 2.5 11 2.5C12.38 2.5 13.5 3.62 13.5 5V15.5C13.5 16.05 13.05 16.5 12.5 16.5C11.95 16.5 11.5 16.05 11.5 15.5V6H10V15.5C10 16.88 11.12 18 12.5 18C13.88 18 15 16.88 15 15.5V5C15 2.79 13.21 1 11 1C8.79 1 7 2.79 7 5V17.5C7 20.54 9.46 23 12.5 23C15.54 23 18 20.54 18 17.5V6H16.5Z" fill="#1B6EBA"/>
          </svg>
          <span class="mrf2__attach-txt">Attach files (Approval)</span>
          <span class="mrf2__doc-hint"> — PDF or image, up to {{ maxPendingFiles }} files</span>
        </label>
        <input
          #approvalFileInput
          type="file"
          hidden
          multiple
          accept=".pdf,application/pdf,image/*"
          (change)="onFilesSelected($event, 'approval')"
        />
        <ul class="mrf2__doc-pending" *ngIf="approvedByPendingFiles.length">
          <li *ngFor="let file of approvedByPendingFiles; let i = index" class="mrf2__doc-pending-item">
            <span class="mrf2__doc-pending-name" [title]="file.name">{{ file.name }}</span>
            <button type="button" class="mrf2__doc-remove" (click)="removePendingFile('approval', i)" aria-label="Remove file">×</button>
          </li>
        </ul>
        <p class="mrf2__doc-meta" *ngIf="approvedByPendingFiles.length">
          {{ approvedByPendingFiles.length }}/{{ maxPendingFiles }} selected — uploads on submit
        </p>
        <span class="mrf2__upload-error" *ngIf="getUploadFileError('approval')">{{ getUploadFileError('approval') }}</span>
      </div>
    </section>

    <!-- 10 Important Guidelines -->
    <section class="mrf2__sec mrf2__sec--gold mrf2__sec--last" aria-labelledby="mrf2-s10">
      <span class="mrf2__step mrf2__step--gold" aria-hidden="true">10</span>
      <h2 id="mrf2-s10" class="mrf2__sec-title mrf2__sec-title--gold">Important Guidelines</h2>
      <div class="mrf2__guide-box">
        <ul class="mrf2__guide">
          <li>
            Any position that is substituted should have a replacement salary that is less than 18% of the current salary.
          </li>
          <li>
            If the new campus is inaugurated under any class, whether it is a replacement or a new branch offering the same programs, the average salary will be applicable
            according to the remaining academic months till the new year.
          </li>
          <li>
            If a new branch offers different programs, align to…
          </li>
        </ul>
      </div>
    </section>

    <footer class="mrf2__footer">
      <button type="button" class="mrf2__btn mrf2__btn--cancel" (click)="cancel()" [disabled]="isSaving">Cancel</button>
      <ng-container *ngIf="showMisApprovalActions">
        <button type="button" class="mrf2__btn mrf2__btn--cancel" (click)="submitMisReview('REJECTED')" [disabled]="isSaving">
          Reject
        </button>
        <button type="button" class="mrf2__btn mrf2__btn--submit" (click)="submitMisReview('APPROVED')" [disabled]="isSaving">
          {{ isSaving ? 'Submitting...' : 'Submit' }}
        </button>
      </ng-container>
      <button
        *ngIf="showHrEditMode"
        type="button"
        class="mrf2__btn mrf2__btn--submit"
        (click)="saveHrStageEdits()"
        [disabled]="isSaving"
      >
        {{ isSaving ? 'Saving...' : 'Save' }}
      </button>
    </footer>
  </div>
</div>

<ng-template #fileChips let-docs="docs">
  <div class="mrf2__file-chips" *ngIf="docs?.length">
    <ng-container *ngFor="let doc of docs">
      <button
        type="button"
        *ngIf="canDownloadDocument(doc); else fileChipStatic"
        class="mrf2__file-chip"
        (click)="onDocumentDownload(doc)"
        [title]="getDocumentName(doc)"
      >
        <span
          class="mrf2__file-chip-ico"
          [class.mrf2__file-chip-ico--pdf]="isPdfFile(doc)"
          [class.mrf2__file-chip-ico--video]="isVideoFile(doc)"
          [class.mrf2__file-chip-ico--img]="isImageFile(doc)"
        >{{ getDocumentIconLabel(doc) }}</span>
        <span class="mrf2__file-chip-name">{{ getDocumentName(doc) }}</span>
      </button>
      <ng-template #fileChipStatic>
        <span class="mrf2__file-chip mrf2__file-chip--static" [title]="getDocumentName(doc)">
          <span
            class="mrf2__file-chip-ico"
            [class.mrf2__file-chip-ico--pdf]="isPdfFile(doc)"
            [class.mrf2__file-chip-ico--video]="isVideoFile(doc)"
            [class.mrf2__file-chip-ico--img]="isImageFile(doc)"
          >{{ getDocumentIconLabel(doc) }}</span>
          <span class="mrf2__file-chip-name">{{ getDocumentName(doc) }}</span>
        </span>
      </ng-template>
    </ng-container>
  </div>
</ng-template>
